module.exports = __webpack_public_path__ + "static/media/Clock.d1115a82.svg";